const phoneNumberLenghth = {
  4: ["683", "690"], // Niue, Tokelau
  5: ["290", "508", "682", "688"], // Saint Helena, Saint Pierre and Miquelon, Cook Islands, Tuvalu
  6: ["262", "298", "299", "508", "676", "687", "689", "681"], // Faroe Islands, Greenland, French Guiana, New Caledonia, French Polynesia, Wallis and Futuna
  7: ["230", "239", "297", "502", "592", "670", "678", "679", "680", "681", "683", "674", "675"], // Aruba, Belize, Solomon Islands, Fiji, Palau, Micronesia, Nauru, Papua New Guinea
  8: ["216", "220", "229", "250", "257", "263", "268", "374", "356", "357", "372", "379", "376", "376", "420", "421"], // Tunisia, Gambia, Togo, Rwanda, Burundi, Zimbabwe, Swaziland, Armenia, Malta, Cyprus, Estonia, Vatican, Andorra, Andorra, Czech Republic, Slovakia
  9: [
    "27",
    "30",
    "31",
    "32",
    "33",
    "34",
    "36",
    "40",
    "41",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "81",
    "82",
    "92",
    "93",
    "94",
    "95",
    "212",
    "213",
    "218",
    "221",
    "223",
    "226",
    "227",
    "230",
    "231",
    "232",
    "233",
    "234",
    "235",
    "237",
    "238",
    "239",
    "240",
    "242",
    "243",
    "244",
    "245",
    "248",
    "249",
    "250",
    "251",
    "252",
    "253",
    "254",
    "255",
    "256",
    "257",
    "258",
    "260",
    "261",
    "262",
    "263",
    "264",
    "265",
    "266",
    "267",
    "268",
    "269",
    "290",
    "291",
    "298",
    "298",
    "351",
    "352",
    "355",
    "356",
    "359",
    "370",
    "371",
    "372",
    "373",
    "374",
    "375",
    "376",
    "377",
    "378",
    "380",
    "381",
    "382",
    "383",
    "385",
    "386",
    "387",
    "389",
    "420",
    "421",
    "423",
    "500",
    "501",
    "502",
    "503",
    "504",
    "505",
    "506",
    "507",
    "508",
    "509",
    "591",
    "592",
    "593",
    "594",
    "595",
    "596",
    "597",
    "598",
    "670",
    "672",
    "673",
    "674",
    "675",
    "676",
    "677",
    "678",
    "679",
    "680",
    "681",
    "682",
    "683",
    "684",
    "685",
    "686",
    "687",
    "688",
    "689",
    "690",
    "691",
    "692",
    "850",
    "852",
    "853",
    "855",
    "856",
    "880",
    "886",
    "960",
    "961",
    "962",
    "963",
    "964",
    "965",
    "966",
    "967",
    "968",
    "970",
    "971",
    "972",
    "973",
    "974",
    "975",
    "976",
    "977",
    "992",
    "993",
    "994",
    "995",
    "996",
    "998",
  ], // A comprehensive list of countries and territories with 9-digit numbers
  10: [
    "1",
    "7",
    "20",
    "91",
    "62",
    "81",
    "66",
    "92",
    "44",
    "52",
    "39",
    "44",
    "30",
    "34",
    "32",
    "52",
    "53",
    "55",
    "60",
    "63",
    "65",
    "93",
    "94",
    "90",
    "234",
    "1",
    "20",
    "51",
    "63",
    "91",
    "94",
    "966",
    "968",
    "977",
    "84",
  ], // USA, Canada, Russia, Egypt, India, Indonesia, Japan, Thailand, Pakistan, UK, Australia, Mexico, Italy, UK, Greece, Spain, Belgium, Mexico, Cuba, Brazil, Malaysia, Philippines, Singapore, Afghanistan, Sri Lanka, Turkey, Nigeria, USA, Egypt, Peru, Philippines, India, Sri Lanka, Saudi Arabia, Oman, Nepal
  11: ["54", "57", "58", "86", "64", "234"], // Argentina, Colombia, Venezuela, China, New Zealand, Nigeria
};

export default phoneNumberLenghth;
